import secure_axios from "../../services/secure_axios";
const initialState  = () =>({
  allleaves: [],
  leaveFormdata: {},
  leavetypes: [],
  compensatoryLeaves:[],
});
const state = initialState();

const getters = {
  allleaves: (state) => state.allleaves,
  leaveFormdata: (state) => state.leaveFormdata,
  leavetypes: (state) => state.leavetypes,
  compensatoryLeaves: (state) => state.compensatoryLeaves,
};

const mutations = {
  setAllLeaves(state, payload) {
    state.allleaves = payload;
  },
  unsetAllLeaves(state) {
    state.allleaves = [];
  },
  clearleaveFormdata(state) {
    state.leaveFormdata = {};
  },
  setleaveFormdata(state, payload) {
    state.leaveFormdata = payload;
  },
  setLeaveTypes(state, payload) {
    state.leavetypes = payload;
  },
  setCompensatoryLeaves(state, payload){
    state.compensatoryLeaves = payload;
  },
  RESET_STATE(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
};

const actions = {
  getAllLeaves({ commit, getters }, payload) {
    commit("setLoading", true);
    commit("clearError");

    const employ_id = payload.employ_id;
    if(payload.isReset){
      commit("unsetAllLeaves");
    }
    

    secure_axios
      .get(
        `${getters.sessionAPI}leaves?employ_id=${employ_id}`
      )
      .then((response) => {
        commit("setAllLeaves", response.data);
        commit("setLoading", false);
      })
      .catch((error) => {
        commit("setLoading", false);
        commit("setError", error);
      });
  },

  // clearAllLeaves({ commit }) {
  //   commit("clearleaveFormdata");
  // },
  clearleaveFormdata({ commit }) {
    commit("clearleaveFormdata");
  },

  setleaveFormdata({ commit }, payload) {
    commit("setleaveFormdata", payload);
  },

  getLeaveTypes({ commit, getters }) {
    secure_axios
      .get(getters.sessionAPI + "leavetypes")
      .then((response) =>
        commit("setLeaveTypes", response.data)
      );
  },
  getCompensatoryLeaves({ commit, getters },payload) {
    const employ_id = payload.employ_id;
    secure_axios
      .get(
      `${getters.sessionAPI}compensatoryleaves?employ_id=${employ_id}`
      )
      .then((response) =>
        commit("setCompensatoryLeaves", response.data)
      ).catch((error) => {
        commit("setLoading", false);
        commit("setError", error);
      });
  },
};

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
};
